import ActionPlansAPI from 'dashboard/api/actionPlans';

const state = {
  records: [],
  uiFlags: { isFetching: false, isCreating: false },
};

const getters = {
  getActionPlans: s => s.records,
  getUIFlags: s => s.uiFlags,
};

const mutations = {
  SET_ACTION_PLANS(state, plans) { state.records = plans; },
  ADD_ACTION_PLAN(state, plan) { state.records.unshift(plan); },
  UPDATE_ACTION_PLAN(state, plan) {
    const idx = state.records.findIndex(p => p.id === plan.id);
    if (idx !== -1) state.records.splice(idx, 1, plan);
  },
  REMOVE_ACTION_PLAN(state, id) {
    state.records = state.records.filter(p => p.id !== id);
  },
  SET_UI_FLAG(state, flags) { state.uiFlags = { ...state.uiFlags, ...flags }; },
};

const actions = {
  async fetch({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await ActionPlansAPI.getPlans(params);
      commit('SET_ACTION_PLANS', data);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, payload) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await ActionPlansAPI.create(payload);
      commit('ADD_ACTION_PLAN', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },
  async complete({ commit }, planId) {
    const { data } = await ActionPlansAPI.complete(planId);
    commit('UPDATE_ACTION_PLAN', data);
  },
  async destroy({ commit }, planId) {
    await ActionPlansAPI.destroy(planId);
    commit('REMOVE_ACTION_PLAN', planId);
  },
};

export default { namespaced: true, state, getters, mutations, actions };
